export default __webpack_public_path__ + "static/assets/316864c7b28097124b92ead8b0524f54.jpg";